import {Component, ViewChild, ElementRef, OnInit, Output, EventEmitter, Input, AfterViewInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IppaymentService} from '../../services/ippayment.service';
import {LoginService} from '../../services/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import {TimerObservable} from 'rxjs/observable/TimerObservable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {Subscription} from 'rxjs/Subscription';
import {environment} from '../../../../app-environments/environment';
import {ServiceBase} from '../../services/service-base';
import {PaymentData} from '../../data-objects/payment-data';

@Component({
  selector: 'app-ippayment',
  templateUrl: './ippayment.component.html',
  styleUrls: ['./ippayment.component.css']
})
export class IppaymentComponent implements OnInit, AfterViewInit  {
  @ViewChild('ipPaymentsFrm') ipPaymentsFrmElement: ElementRef;
  @Input()
  paymentData: PaymentData;
  @Input()
  parentForm: string;
  isRunning: boolean;
  timerSubscription: Subscription;
  timerSubscriptionForCheckoutSession: Subscription;
  imageSourceUrl = ServiceBase.baseHref + '/assets/images/spinner1.gif';

  constructor(private loginService: LoginService, private ipPaymentService: IppaymentService, private route: ActivatedRoute,
              private router: Router, private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.isRunning = false;
    if (this.paymentData && this.paymentData.sessionAlreadyExists && this.paymentData.isPaymentDone) {
      this.checkPaymentStatus();
      this.setDefaultHeight();
    } else {
      /*const timer = TimerObservable.create(500, 500);
      this.timerSubscriptionForCheckoutSession = timer.subscribe(t => {
        this.ipPaymentService.paymentformIsInit.emit(null);
        this.timerSubscriptionForCheckoutSession.unsubscribe();
      });*/
    }
  }

  receiveMessage: any = (event: any) => {
    if (!event.origin.startsWith('')) {
      return;
    }

    if (event.data !== 'onPay') {
      this.isRunning = true;
      const timerTime: number = environment.envName === 'prod' ? 7000 : 12000;
      const timer = TimerObservable.create(timerTime, timerTime);
      this.timerSubscription = timer.subscribe(t => {
        this.isRunning = false;
        this.timerSubscription.unsubscribe();
        this.timerSubscription = null;
      });
    } else if (event.data !== 'onPaymentDone') {
      this.paymentData.isPaymentDone = true;
    }
  }

  onContentLoad() {
    try {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
      this.isRunning = false;
      if (this.ipPaymentsFrmElement.nativeElement.contentDocument
        && this.ipPaymentsFrmElement.nativeElement.contentDocument.URL.indexOf('paymentStatus') > -1) {
        this.ipPaymentsFrmElement.nativeElement.style.height = '170px';
        this.paymentData.isPaymentDone = true;
      } else {
        this.setDefaultHeight();
      }
    } catch (err) {
    }
  }

  setDefaultHeight(): void {
    this.ipPaymentsFrmElement.nativeElement.style.height = '560px';
  }

  onContentUnload() {
    this.isRunning = true;
  }

  checkOutPaymentSession(custRef: string, custNumber: string
    , amount: string, callback: (sessionId: string, sst: string, error: any) => void): void {
    const me: IppaymentComponent = this;
    this.ipPaymentService.checkoutIpPaymentSession(custRef, custNumber, amount, this.loginService.getToken()).subscribe((data: any) => {
        me.ipPaymentsFrmElement.nativeElement.src = data.redirectUrl;
        me.paymentData.sessionId = data.sessionId;
        me.paymentData.isPaymentDone = false;
        me.paymentData.sessionAlreadyExists = true;
        me.paymentData.sst = data.sst;
        if (callback) {
          callback(data.sessionId, data.sst, null);
        }
      },
      (error) => {
        callback('', '', error);
      }
    );
  }

  checkPaymentStatus(): void {
    const me: IppaymentComponent = this;
    me.ipPaymentsFrmElement.nativeElement.src = IppaymentService.checkPaymentStatusUrl + '?sst=' + this.paymentData.sst +
      '&sessionId=' + this.paymentData.sessionId;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/ippayment/ippayment.component.ts